import React from 'react';

const ArrowDown = () => {
  return (
    <svg
      height={16}
      viewBox='0 0 8 5'
      width={16}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4 3.001L0 0v2l4 3.001L8.001 2V0z'
        fill='#111'
        fillRule='evenodd'
      />
    </svg>
  );
};

export default ArrowDown;
